import instanceQuery from 'graphql/queries/vat/VatReconciliationQuery.graphql';

const VatRate = {
  type: 'VatReconciliation',
  shortTitle: 'Reconciliation',
  title: 'VAT Reconciliation',
  formTitle: 'VAT Reconciliation',
  formUrl: '/Vat/Reconciliation/',
  instance: instanceQuery,
  screenReference: 'VAT_RECONCILIATION',
  actions: [
    {
      description: 'Vat Audit Report',
    },
  ],
};

export default VatRate;
